import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import {LoginAsTech} from "../../../services/auth.service"
import { getTecnicos, deleteTecnico, getAllEquipos } from "../../../services";
import { Link } from "react-router-dom";
import Add from "../../../icons/add.svg";
import Lupa from "../../../icons/lupa.svg";
import Delete from "../../../icons/delete.svg";
import Editar from "../../../icons/editar.svg";
import { Login } from '@mui/icons-material';
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import ExportarListaTecnicos from "./ExportarListaTecnicos";
import Excel from "../../../icons/excel.svg";
import { UsuarioContext } from "../../../providers/userContext";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { Box, Tooltip } from "@mui/material";
import { DataTable } from "../../../components";
import FiltrosPersonal from "../../../components/filtros/filtrosPersonal";
import { useLocation, useNavigate } from 'react-router-dom';
import { construirURLParamsFiltros, useRecogerURLParamsFiltros } from "../../../functions/parametrosURL/funcionesParamsURL";

const Tecnicos = () => {
  const { t } = useTranslation('common');
  const urlPadre = window.location.pathname;
  const navigate = useNavigate();
  const {filtrosIniciales, filtroOrder} = useRecogerURLParamsFiltros();
  const user = useContext(UsuarioContext)
  const [tecnicos, setTecnicos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(true);
  const [show, setShow] = useState(false);
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [equipos, setEquipos] = useState([]);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });

  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem("hasReloaded") === "true") {

      fetchData();
      localStorage.setItem("hasReloaded", "false"); 
    }
  }, [location]);
  

  useEffect(() => {
    getAllEquipos()
      .then((res) => setEquipos(Array.isArray(res) ? res : []))
      .catch(() => setEquipos([]));
  }, []);

  const filtrarDatos = (filtros) => {
    setBusqueda({ ...filtros });
    setBusquedaActiva(true);
  };

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  };

  const fetchData = async ({ offset, limit, filtros = busqueda, order,orderBy, } = {}) => {


    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order =   order || filtroOrder.orden || 'ASC';

    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros,  order,orderBy,);
    
    const payload = {
      filtros,
      params: { page: offset, limit,  order,orderBy, },
    };
    try {
      setLoading(true);
      const response = await getTecnicos(payload);
      const { meta, data } = response;
      setTecnicos(data)
      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const formatData = (data) => {
    return data.map((row, i) => ({
      id: i+1,
      nombre: row.nombre+" "+row.apellidos,
      nif: row.nif,
      telefono: row.telefono,
      email: row.user.email,
      provincia: row.provincia,
      equipo: row.technicianteams?.nombre
    }));
  };

  const comercialesRows = [

    {
      id: "nombre",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.technician'),
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.nif'),
    },
    {
      id: "telefono",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.phone'),
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.email'),
      noObjeto: true,
    },
    {
      id: "equipo",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.team'),
      noObjeto: true,
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.province'),
    },
    {
      id: "aaff",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.propertyManagers'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Link to={"/tecnicos/" + row.nif + "/aaff"}>
          <img
            src={Lupa}
            alt={t('technicians.columns.propertyManagers')}
            className="tableIcon"
          ></img>
        </Link>
      )
    },
    (user.rol === 'ADMIN' || user.rol === 'CONSUL') ?
    {
      id: "editar",
      numeric: false,
      disablePadding: false,
      label: t('actions.edit'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Link to={"/tecnicos/editar/" + row.nif}>
          <img
            src={Editar}
            alt={t('actions.edit')}
            className="tableIcon"
          ></img>
        </Link>
      )
    }
    :
    {
      noObjeto: true
    },
    user.rol === 'ADMIN' ?
    {
      id: "eliminar",
      numeric: false,
      disablePadding: false,
      label: t('technicians.columns.delete'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <img
          src={Delete}
          alt={t('actions.delete')}
          className="tableIcon"
          onClick={() => eliminarTecnico(row)}
        ></img>
      )
    }
    :
    {

      noObjeto:true

    },
    user.rol === 'ADMIN' ?
    {
      id: "login",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Tooltip title={t('messages.loginAs', { name: row.nombre })} >
          <div className="bigBtn p-2" onClick={() => {LoginAsTech(row.nif)}}>
            <Login fontSize="small" />
          </div>
        </Tooltip>
      )
    }
     :
    {

      noObjeto:true

    },
  ]

  const eliminarTecnico = (com) => {
    let nombre = com.nombre + " " + com.apellidos;
    Swal.fire({
      title: t('technicians.messages.confirmDelete'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: t('actions.cancel'),
      confirmButtonText: t('messages.yesDelete'),
    })
      .then((result) => {
        if (result.isConfirmed) {

          deleteTecnico(com.nif)
            .then((res) => {

              if (res.message === "TECHNICIAN_DELETED") {
                toast.success(t('technicians.messages.deleted'));
                setRecargar(!recargar);
              } else {
                toast.error(t('technicians.messages.deleteError'));
              }
            })
            .catch((e) => {
              toast.error(t('technicians.messages.deleteError'));
              console.log(e);
            });
        }
      })
      .catch((e) => {
        toast.error(t('messages.error'));
        console.log(e);
      });
  };

  return (
    <>
      <BreadCrumb rutas={[{path:`/tecnicos`, label: t('technicians.title')}]} />
      <div className="listPage">
        <div className="gridCard">
            <div className="gridHead">
                {t('technicians.title').toUpperCase()}
            </div>
        </div>
      </div>
      <div className="pageContent tableContainer">
        <div className="contentBar">
          <div style={{ display: 'flex'}}>
            {show ? (
              <ExportarListaTecnicos tecnicos={tecnicos} filtros={busqueda} />
            ) : (
              <button className="bigBtn" onClick={() => setShow(true)}>
                <img src={Excel} alt={t('technicians.generateList')} width="30px" /> {t('technicians.generateList')}
              </button>
            )}
            <Link to="/equipos">
              <div className="bigBtn">
                <>{t('technicians.viewTeams')}</>
              </div>
            </Link>
          </div>
          {(user.rol === "ADMIN" || user.rol === "CONSUL" || user.rol !== "VENT") &&
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'end'}}>
              <Link to="/tecnicos/nuevo">
                <div className="contentButton mx-2">
                  <img src={Add} alt={t('technicians.new')} />
                </div>
              </Link>
            </div>
          }
        </div>
        <FiltrosPersonal
          onFilter={filtrarDatos}
          clearFilter={clearFilters}
          filtrosIniciales={busqueda}
          conProvincia={true}
          equipos={equipos}
        />
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={comercialesRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('technicians.messages.noTechnicians')}
              />
            </Box>
          </Box>
        </div>

      </div>
    </>
  );
};

export default Tecnicos;
